import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, FormGroup, Input, Col, Form, Button, Label} from 'reactstrap';
import _ from 'lodash';
import {Utils} from "../../../utils/utils";
import './ChangeBalanceModal.css';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import {CURRENCIES} from '../../../constants/constants';
import FormWrapper from '../../commonComponents/formWrapper/FormWrapper.container';
import Select from '../../commonComponents/customSelect/CustomSelect.container';

const INCREASE = 'INCREASE';
const DECREASE = 'DECREASE';

class ChangeBalanceModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mode: INCREASE,
            amount: Number(1).toFixed(2),
            currency: 'USD',
            comment: ''
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isNil(nextProps.data) && (!_.isEqual(nextProps.data, this.props.data))) {
            this.setState({currency: nextProps.data.balanceCurrency});
            this.cleanData();
        }

        if (this.props.isOpen && !nextProps.isOpen) {
            this.cleanData();
        }
    }

    render() {
        if (_.isNil(this.props.data) || _.isNil(this.props.currenciesData)) {
            return null;
        }

        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.onCancel}>
                <ModalBody>{this.renderModalBody()}</ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        return (
            <Form onSubmit={this.onSubmit}>
                <FormWrapper>
                    <h4 className="text-center">{_.get(this.props.translation, 'finance.change_balance_label')}</h4>
                    <div className="current-balance-label">
                        <h6>{_.get(this.props.translation, 'finance.balance_label') + ": "}</h6>{this.props.data.balance + CURRENCIES[this.props.data.balanceCurrency]}
                    </div>
                    <Label className="change-balance-modal-label">
                        {_.get(this.props.translation, 'finance.change_balance_modal_label')}
                    </Label>
                    <FormGroup row>
                        <Col sm={5}>
                            <Select
                                selectedOption={{
                                    value: this.state.mode,
                                    label: _.get(this.props.translation, 'finance.' + this.state.mode.toLowerCase() + '_label')
                                }}
                                options={Utils.getOptions([
                                    {code: INCREASE, name: _.get(this.props.translation, 'finance.increase_label')},
                                    {code: DECREASE, name: _.get(this.props.translation, 'finance.decrease_label')}
                                ])}
                                onSelect={this.handleChangeSelect("mode")}
                                isSearchable={false}
                            />
                        </Col>
                        <Col sm={4}
                            className={"change-balance-amount-container change-balance-amount-container-" + (this.state.mode === INCREASE ? "increase" : "decrease")}>
                            <Input
                                className={"change-balance-amount-input " + (this.state.mode === INCREASE ? "change-balance-amount-input-increase" : "change-balance-amount-input-decrease")}
                                type="number"
                                min={0}
                                step="any"
                                value={this.state.amount}
                                onChange={this.handleChangeAmount}
                                onBlur={this.handleBlur}
                                onKeyDown={this.handleKeyDown}
                                required
                            />
                        </Col>
                        <Col sm={3} className="change-balance-currency-select-container">
                            <Select selectedOption={this.getCurrencySelectedOption()}
                                    options={Utils.getCurrenciesOptions(this.props.currenciesData)}
                                    onSelect={this.handleChangeSelect("currency")}
                                    isSearchable={false}/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col>
                            <Input type="textarea"
                                   value={this.state.comment}
                                   onChange={this.handleChange("comment")}
                                   placeholder={_.get(this.props.translation, 'finance.balance_change_comment_placeholder')}
                                   required
                            />
                        </Col>
                    </FormGroup>
                    <div className="modal-buttons-container">
                        <Button color="secondary"
                                onClick={this.props.onCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                        <Button className="olive-green-btn"
                                disabled={this.submitButtonDisabled()}
                                type="submit">{_.get(this.props.translation, 'finance.change_balance_submit_button')}</Button>
                    </div>
                </FormWrapper>
            </Form>
        );
    }

    submitButtonDisabled = () => {
        return this.state.amount <= 0;
    };

    handleChange = (fieldKey) => (e) => {
        this.setState({[fieldKey]: e.target.value});
    };

    handleChangeSelect = (fieldKey) => (selectedOption) => {
        this.setState({[fieldKey]: selectedOption.value});
    };

    handleChangeAmount = (e) => {
        this.setState({amount: e.target.value});
    };

    handleBlur = () => {
        let newValue = Number(this.state.amount);
        let newMode = this.state.mode;

        if (Number(newValue) < 0) {
            newValue = -newValue;
            newMode = newMode === INCREASE ? DECREASE : INCREASE;
        }

        this.setState({
            amount: newValue.toFixed(2),
            mode: newMode
        });
    };

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
        }
    };

    getCurrencySelectedOption = () => {
        return _.find(Utils.getCurrenciesOptions(this.props.currenciesData), currency => currency.value === this.state.currency);
    };

    onSubmit = (e) => {
        e.preventDefault();

        if (Number(this.state.amount) > 0) {
            let data = {
                delta: {
                    amount: (this.state.mode === DECREASE ? "-" : "") + this.state.amount,
                    currency: this.state.currency
                }
            };
            if (this.state.comment !== '') {
                data['comment'] = this.state.comment;
            }
            this.props.onChangeBalance(this.props.data.id, data);
        }
    };

    cleanData = () => {
        this.setState({
            mode: INCREASE,
            amount: Number(1).toFixed(2),
            comment: ''
        });
    }
}

ChangeBalanceModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    data: PropTypes.object,
    currenciesData: PropTypes.array,
    translation: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    onChangeBalance: PropTypes.func.isRequired
};

export default ChangeBalanceModal;



// WEBPACK FOOTER //
// ./src/components/organizationManagement/changeBalanceModal/ChangeBalanceModal.js